import {redirectToLogin} from "../utils/redirectToLogin";
import {sendSurvey} from "./sendSurvey";
export function initSurvey(){
    $(document).on("click", ".post_survey", function (e) {
        e.preventDefault();
        if (shopUserId !== "") {
            var container,
                checkedIds,
                surveyId = 0,
                timelineId = 0;
            if ($(this).hasClass("survey_of_the_month")) {
                container = $(this).closest(".community_survey_of_month");
                surveyId = container.attr("id").split("_")[3];
                checkedIds = [];
                $.each(container.find('.answers input[type="checkbox"]:checked'), function (key, value) {
                    checkedIds.push($(value).attr("id").split("_")[2]);
                });
            } else {
                container = $(this).closest(".survey_entry");
                timelineId = container.attr("id");
                checkedIds = [];
                var type = container.attr("data-type");
                if (parseInt(type) === 1) { // Einfachantwort
                    var answer = container.find('.answers input[type="radio"]:checked');
                    if (answer.length) {
                        checkedIds.push(answer.attr("id").split("_")[3]);
                    }
                } else { // Mehrfachantwort
                    $.each(container.find('.answers input[type="checkbox"]:checked'), function (key, value) {
                        checkedIds.push($(value).attr("id").split("_")[3]);
                    });
                }
            }

            sendSurvey(surveyId, timelineId, checkedIds);
        } else {
            redirectToLogin();
        }
    });
}
